import { oz } from '@weft/utils';

export const WarmUpFlagPayloadSchema = oz.object({
  isWarmUp: oz.boolean(),
});

export type WarmUpFlagPayload = oz.infer<typeof WarmUpFlagPayloadSchema>;